<template>
  <div v-if="inital">
    <notifications />
    <div v-if="user" :class="{ 'nav-open': $sidebar.showSidebar }">
       <template v-for="(card, key) in $route.query">
          <component
            :key="key"
            :is="key"
            :style="{
              zIndex: priority[key] ? priority[key] : 3,
            }"
            v-if="items[key]"
            :id="card"
          />
        </template>
      <router-view />
    </div>
    <div v-else>
      <login />
    </div>
  </div>
</template>

<script>
import login from "./pages/Login";

import { mapState } from "vuex";

export default {
  data: () => ({
    inital: false,
    audio: null,
    priority: {},
    isCard: false,
  }),
  components: {

    login,
  },
  created() {
    this.languages();
  },
  computed: {
    ...mapState(["user", "modalName","items"]),
  },
  methods: {
    languages() {
      this.$http
        .get("system/languages")
        .then((response) => {
          this.$store.dispatch("setLanguages", response.data);
          this.locations();
        })
        .catch(() => {})
        .finally(() => {});
    },
    locations() {
      this.$http
        .get("system/locations")
        .then((response) => {
          this.$store.dispatch("setLocations", response.data);
        })
        .catch(() => {})
        .finally(() => {});
    },
    pushNotifiction(message) {
      if (this.$notification) {
        this.$notification.show(
          "UCELL",
          {
            body: message,
            icon: "@/assets/img/logo.png",
          },
          {}
        );
      }
    },
    initSocket() {
      this.$socket.$subscribe("laravel_database_order-admin", (payload) => {
        if (!payload.is_update || payload.is_update === false) {
          this.$notify({
            title: "Заказ #" + payload.order.id,
            message: "У вас новый заказ",
            icon: "ti-shopping-cart",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "info",
          });
          this.pushNotifiction("Заказ #" + payload.order.id);
          this.audio.play();
        }
        this.$store.dispatch("setNewOrder", Date.now());
      });
    },
  },
  mounted() {
    this.audio = new Audio("./notify.mp3");
    this.$loading(true);
    this.$http
      .get("users/info")
      .then((response) => {
        this.$store.dispatch("setUser", response.data);
        // this.initSocket();
      })
      .catch(() => {})
      .finally(() => {
        this.inital = true;
        setTimeout(() => {
          this.$loading(false);
        }, 400);
      });
  },
  watch: {
     modalName(val) {
      if (val) {
        setTimeout(() => {
          this.$modal.show(val.model);
        }, 10);
      }
    },
    "$route.query": {
      handler: function (val) {
        let k = 1;
        let isOpened = false;
        for (var key in val) {
          if (this.items[key]) {
            isOpened = true;
          }
          k++;
          this.priority[key] = 3 + k;
        }

        if (isOpened === true) {
        
          document.body.classList.add("hidden");
        } else {
          document.body.classList.remove("hidden");
        }
        this.isCard = isOpened;
      },
      deep: true,
      immediate: true,
    },
    user: {
      handler: function (val) {
        //  console.log(val);
        if (val) {
          this.languages();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
